module.exports = __webpack_public_path__ + "static/media/users-opinions.2d969a59.svg";